import type { ParsedQs } from 'qs';

export function getQueryStringSingleValue(query: ParsedQs, name: string): string | undefined {
	const possibleArrayValue = query[name];
	const value = Array.isArray(possibleArrayValue) ? possibleArrayValue[0] : possibleArrayValue;
	return typeof value === 'string' ? value : undefined;
}
